module.exports = __webpack_public_path__ + "media/img/favicon-f2d7f24f33f38db44635aabfe9491884.ico";